import localforage from 'localforage';
import memoryDriver from 'localforage-memoryStorageDriver';

import axios from 'axios';
import { baseURL } from './env-variables';

const URL_CACHED = ['dados-pessoais', 'residenciais'];

const getURLCached = (req) => {
  const { url } = req;
  const urlMapped = URL_CACHED.map((pattern) => {
    const patternRegexp = new RegExp(pattern);
    return patternRegexp.test(url);
  });
  const shouldCached = urlMapped.includes(true);
  return !shouldCached;
};

localforage.defineDriver(memoryDriver);
const localforageStore = localforage.createInstance({
  driver: [localforage.LOCALSTORAGE, localforage.INDEXEDDB],
  name: 'caching_service',
});

const headers = {
  Authorization: 'Basic b25yZm9ybHV6OiFAIyQlXiYqKCk=',
  tknFlz: 'sowzcnv2ftks57w35mhufxsop37df3bo35x7ggdgobps33sewbtq',
  originAplication: window.location.origin,
};

const api = axios.create({
  baseURL,
  headers,
  cache: {
    maxAge: 2 * 60 * 1000,
    store: localforageStore,
    exclude: {
      filter: (req) => getURLCached(req), // true não cacheia, false cacheia
      query: false,
    },
  },
});

export const cardeal = {
  get: (metodo = '', obj = { params: {} }) =>
    api.get('ObterDadosCardeal', {
      params: {
        metodo,
        token: localStorage.getItem('Token') || '',
        ...obj.params,
      },
    }),

  post: (metodo = '', payload = {}) =>
    api.post('RegistrarDadosCardeal', {
      metodo,
      token: localStorage.getItem('Token') || '',
      ...payload,
    }),
};

api.interceptors.response.use(
  (response) => {
    return response;
  },
  () => {
    window.dispatchEvent(new Event('logout'));
  }
);

export default api;
